import React from "react";
import { Icon } from "@iconify/react";
import style from "../../../scss/Agenda.module.scss";
import BotonIconoComponent, { AccionesTabla, BotonEditar, BotonEliminar } from "../../../components/BotonIconoComponent";
import { esDeVotante, formatearFecha, formatearHora, recordatorio, relacionesCompromiso } from "../../../utils/agenda";

const MESES_CORTOS = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];

// Bloque de fecha estilo calendario: día grande y mes abreviado
const HojaCalendario = ({ fecha }) => {
  if (!fecha) {
    return (
      <span className={`${style.hoja} ${style.hojaSinFecha}`} aria-hidden="true">
        <Icon icon="mdi:calendar-blank-outline" />
      </span>
    );
  }
  const [, mes, dia] = fecha.split("-").map(Number);
  return (
    <span className={style.hoja} aria-hidden="true">
      <strong>{dia}</strong>
      <small>{MESES_CORTOS[mes - 1]}</small>
    </span>
  );
};

// Un compromiso de la agenda: fecha, descripción, aviso y acciones.
// Los compromisos con votantes se editan o eliminan desde la consulta de
// electores; aquí solo se marcan como cumplidos (si el usuario tiene permiso).
const CompromisoAgendaComponent = ({ compromiso, editando, puedeCambiarEstado, onCambiarEstado, onEditar, onEliminar }) => {
  const aviso = recordatorio(compromiso);
  const deVotante = esDeVotante(compromiso);

  return (
    <li className={`${style.item} ${style[aviso.tipo]} ${editando ? style.itemEditando : ""}`}>
      <HojaCalendario fecha={compromiso.fecha} />

      <div className={style.contenido}>
        <p className={style.descripcionCompromiso}>{compromiso.descripcion}</p>
        <div className={style.meta}>
          {deVotante && (
            <span className={style.origen} title="Compromiso registrado con el votante">
              <Icon icon="mdi:handshake-outline" aria-hidden="true" /> Compromiso con votante
            </span>
          )}
          {compromiso.fecha && (
            <span className={style.fechaLarga}>
              {formatearFecha(compromiso.fecha)}
              {compromiso.hora && ` · ${formatearHora(compromiso.hora)}`}
            </span>
          )}
          <span className={style.aviso}>{aviso.texto}</span>
          {relacionesCompromiso(compromiso).map((relacion) => (
            <span key={relacion.titulo} className={style.relacion} title={relacion.titulo}>
              <Icon icon={relacion.icono} aria-hidden="true" />
              {relacion.texto}
            </span>
          ))}
        </div>
      </div>

      <AccionesTabla>
        {puedeCambiarEstado && (
          <BotonIconoComponent
            icono={compromiso.cumplido ? "mdi:undo-variant" : "mdi:check-bold"}
            etiqueta={compromiso.cumplido ? "Marcar como pendiente" : "Marcar como cumplido"}
            variante={compromiso.cumplido ? "neutro" : "exito"}
            onClick={() => onCambiarEstado(compromiso)}
          />
        )}
        {deVotante ? (
          <BotonIconoComponent
            icono="mdi:account-search-outline"
            etiqueta="Ver el votante en la consulta"
            variante="neutro"
            onClick={() => {
              window.location.href = "/consulta";
            }}
          />
        ) : (
          <>
            <BotonEditar etiqueta="Editar compromiso" onClick={() => onEditar(compromiso)} />
            <BotonEliminar etiqueta="Eliminar compromiso" onClick={() => onEliminar(compromiso)} />
          </>
        )}
      </AccionesTabla>
    </li>
  );
};

export default CompromisoAgendaComponent;
